import type { ReactNode, RefObject } from 'react';

export function ChatConversation({ children, innerRef }: { children: ReactNode; innerRef: RefObject<HTMLDivElement> }) {
  return (
    <>
      {/* Relative flex container */}
      <section className="relative flex grow flex-col">
        {/* Use absolute positioning with reverse-column to set an overflow scrolling block and natural push the content to bottom */}
        <div aria-live="polite" className="scroller absolute inset-0 flex flex-1 flex-col gap-4 overflow-y-auto p-2">
          {/* Since we're using reverse-column use a single child to manage easier the reverse order of dom elements*/}
          <div className="flex grow flex-col">
            {/* style a single growable overflow element that handles conversation chat within the UI*/}
            <div className="divide-border flex grow flex-col gap-5 divide-y pb-4">{children}</div>
            {/* Scroll anchor to scroll to bottom on chat input*/}
            <div aria-hidden="true" className="h-0" ref={innerRef} />
          </div>
        </div>
      </section>
    </>
  );
}
